<template>
	<div>
		<div class="">
			<StockPlates :symbol_code="symbol_code"></StockPlates>
		</div>
		<div class="clearfix">-</div>
		<div class="row clearfix">
			<StockUpLimitReason :symbol_code="symbol_code"></StockUpLimitReason>
		</div>
		<div class="mt-2">
			<b-form-checkbox id="status_popular" v-model.number="status_popular" name="status_popular" value="1"
				unchecked-value="0">
				人气
			</b-form-checkbox>
		</div>
		<div class="row">
			<div class="col-9">
				<div v-if="!is_show_popular" class="">
					<StockKlineDay :chart_width="'100%'" :chart_heigh="chart_heigh" :chart_rank_line="chart_rank_line"
						:symbol_code="symbol_code" :title="symbol_name" :subText="symbol_code" @date-selected="onDateSelected"></StockKlineDay>
				</div>
				<div v-if="is_show_popular" class="">
					<StockKlineWithPopular :chart_width="'100%'" :chart_heigh="chart_heigh"
						:chart_rank_line="chart_rank_line" :symbol_code="symbol_code" :title="symbol_name"
						:subText="symbol_code" :highlightDate="selectedDate" @date-selected="onDateSelected"></StockKlineWithPopular>
				</div>
			</div>
			<div class="col-3">
				<StockTrend :chart_width="'100%'" :chart_heigh="'400px'" :symbol_code="symbol_code"
					:title="symbol_name" :subText="symbol_code" :selected_date="clickedDate"></StockTrend>
			</div>
		</div>

		

		<div class="clearfix"></div>

	</div>
</template>

<script>
	import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'
	import StockTrend from 'components/stock/StockTrend.vue'
	import StockPlates from 'components/stock/StockPlates.vue'
	import StockUpLimitReason from 'components/stock/StockUpLimitReason.vue'
	import 'echarts/lib/chart/line'
	import "echarts/lib/chart/bar";
	import "echarts/lib/chart/candlestick";
	import 'echarts/lib/component/title'
	import "echarts/lib/component/dataZoom";
	import "echarts/lib/component/axis";
	import "echarts/lib/component/axisPointer";
	import "echarts/lib/component/tooltip";
	import "echarts/lib/component/toolbox";
	import "echarts/lib/component/legend";
	import "echarts/lib/component/markLine";
	import "echarts/lib/component/markPoint";
	import "echarts/lib/component/markArea";
	import "echarts/lib/component/timeline";
	import "echarts/lib/component/visualMap";



	const upColor = '#ec0000';
	export default {
		props: {
			symbol_code: String,
			symbol_name: String,
			selectedDate:String,
			chart_width: {
				type: String,
				default: "600px",
			},
			chart_heigh: {
				type: String,
				default: "600px",
			}
		},
		computed: {
			is_show_popular() {
				// console.log(this.status_popular);
				return new Number(this.status_popular) == 1;
			},
			adjustedChartWidth() {
				// 你需要确保chart_width是一个包含数值的字符串，如"800px"
				// let width = parseInt(this.chart_width, 10);
				// return `${width - 200}px`;
				return '600px';
			}
		},
		data() {
			return {
				status_popular: 1,
				chart_rank_line: {
					width: 1,
					opacity: 0.3,
					color: upColor
				},
				clickedDate: '', // 添加存储点击的日期
				// chart_width: '800px',
				// chart_heigh: '600px',
			};
		},
		components: {
			StockKlineWithPopular,
			StockKlineDay,
			StockTrend,
			StockPlates,
			StockUpLimitReason
		},
		methods: {
			// 添加处理日期选择的方法
			onDateSelected(date) {
				this.clickedDate = date;
			},
		}
	}
</script>

<style>
</style>